import { render, staticRenderFns } from "./step-area.vue?vue&type=template&id=2e790977&"
import script from "./step-area.vue?vue&type=script&lang=js&"
export * from "./step-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports